import React, {useState} from 'react';
import styled from 'styled-components';
import PlayIcon from '../../assets/inline-svg/icons/play.svg';
import Img from 'gatsby-image';

const PLAY_TRANSITION = 200;

const VideoContainer = styled.div`
  position: relative;
  display: inline-flex;
  border-radius: 4px;
  width: ${({isWide}) => isWide ?
    '660px' :
    '480px'};
  max-width: 100%;
  height: auto;
  overflow: hidden;
`;

const StyledVideo = styled.video`
  outline: none;
  width: 100%;
  height: 100%;
  transition: opacity ${PLAY_TRANSITION}ms;
`;

const ThumbnailOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #000000;
  z-index: 1;
  cursor: pointer;
  
  .image-wrapper {
    width: 100%;
    height: 100%;
    opacity: 0.4;
  }

  svg {
    position: absolute;
    top: calc(50% - 37px);
    left: calc(50% - 37px);
    width: 74px;
    height: 74px;
    transform: scale(0.8,0.8);
    transition: transform 300ms;
    z-index: 2;
  }
  
  &:hover svg {
    transform: scale(1,1);
  }
`;

export const Video = ({videoSrc, thumbnailSrc, isWide, text}) => {
  const [clicked, setClicked] = useState(false);
  const videoRef = React.useRef(null);

  const handleThumbnailClick = (_) => {
    setClicked(true);
    setTimeout(() => {
      videoRef.current.play().then(() => {
      });
    }, PLAY_TRANSITION);
  };

  return (
      <VideoContainer>
        {
          !clicked &&
          <ThumbnailOverlay onClick={handleThumbnailClick}>
            <PlayIcon/>
            <div className="image-wrapper">
              <Img fluid={thumbnailSrc.fluid}/>
            </div>
          </ThumbnailOverlay>
        }
        <StyledVideo controls ref={videoRef} isWide={isWide}
                     style={{opacity: clicked ? '1' : '0'}}
                     playsinline
                     preload="none">
          <source src={videoSrc}
                  type="video/mp4"/>
        </StyledVideo>
      </VideoContainer>
  );
};
